export function useIncident() {
  const incidentId = incidentIdFromRoute();

  function incidentIdFromRoute(): string {
    const url = new URL(window.location.href);
    const match = url.pathname.match(/\/incident\/([^/]+)/);
    if (match) {
      return decodeURIComponent(match[1]);
    }
    throw new Error("Incident ID not found in route");
  }

  return {
    incidentId
  };
}
